module.exports = __webpack_public_path__ + "static/img/business4.458e91e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/business4.png
// module id = X8ii
// module chunks = 3